module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// /opt/app/develop/src/app/pages/home/home-page-root.component.html
// module id = ../../../../../src/app/pages/home/home-page-root.component.html
// module chunks = 0